import { render, staticRenderFns } from "./AllDids.vue?vue&type=template&id=bbd9fd94&scoped=true&"
import script from "./AllDids.vue?vue&type=script&lang=js&"
export * from "./AllDids.vue?vue&type=script&lang=js&"
import style0 from "./AllDids.vue?vue&type=style&index=0&id=bbd9fd94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd9fd94",
  null
  
)

component.options.__file = "AllDids.vue"
export default component.exports